import Vue from 'vue'
import App from './App.vue'
import store from './store/index'
import router from './router/index'
import element from './components/element'
import { Message } from 'element-ui'
import i18n from './i18n/i18n'
import './assets/scss/index.scss'
import './assets/scss/theme.scss'
import api from './http/api'
import * as filters from './utils/filters.js'
import gotinTrack from '@frontend/gotin-track'
import VueGtag from 'vue-gtag'
import { param2Obj } from './utils/utils.js'

const { name } = param2Obj(window.location.href)

// G-K6S5PNWNYN
const gtagConfigMap = {
  porsche911: {
    config: { id: 'UA-36876318-1' },
    includes: [{ id: 'G-T3YBBYBN79' }],
  },
  porschetaycan: {
    config: { id: 'G-K6S5PNWNYN' },
  },
}
const gtagConfig = gtagConfigMap[name]

if (gtagConfig) {
  Vue.use(VueGtag, { ...gtagConfig }, router)
}

// 插入过滤器名和对应方法
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})

Vue.prototype.$api = api
Vue.prototype.$message = Message

const isMobile = !!navigator.userAgent.match(/iPhone|iPad|iPod|Android/i)
const needHeartbeatItems = [
  'porsche911',
  'porschetaycan',
  'aia',
  'aia-hr',
  'njcb-meets',
  'porsche718',
  'hr',
  'nissan',
  'takedaspark',
  'aiahrn',
]

Vue.use(gotinTrack, {
  app_key: isMobile ? 'mobile' : 'pc',
  app_v: '0.1.0',
  project: 'gotin',
  pageName: 'home',
  isLoginProject: true,
  is3d: name && name === 'porsche911',
  heartbeat: needHeartbeatItems.includes(name),
  topicOptions: {
    useDefault: true,
  },
  debuggerStatus: false,
})
Vue.use(element)
Vue.config.productionTip = false
Vue.mixin({
  directives: {
    focus: {
      inserted: function (el) {
        el.querySelector('input').focus()
      },
    },
  },
  computed: {
    isMobile: {
      get() {
        return store.state.isMobile
      },
    },
  },
})

function setIsMobile() {
  let isMobile = document.body.clientWidth <= 992
  store.commit('setState', { isMobile: isMobile })
}
let timer = null
window.addEventListener('resize', () => {
  clearTimeout(timer)
  timer = setTimeout(() => {
    setIsMobile()
  }, 1000)
})

setIsMobile()
new Vue({
  store,
  router,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
